import { SidebarProvider } from "@backpac/monica";
import { OverlayProvider } from "overlay-kit";

export function GlobalProviders({ children }: { children: React.ReactNode }) {
  return (
    <OverlayProvider>
      <SidebarProvider>{children}</SidebarProvider>
    </OverlayProvider>
  );
}
